import { render, staticRenderFns } from "./CreateFxRateDialog.vue?vue&type=template&id=498a108c&"
import script from "./CreateFxRateDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateFxRateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports